export default "__VITE_ASSET__e3b047f2__"